import styled from "styled-components";

export const FloatingDiv = styled.div`
	display: flex;
	position: fixed;
	bottom: 0;
	left: 0;
	opacity: 0;
	pointer-events: none;
	width: 100vw;
	background-color: #1b1b1b;
	color: #f1f1f1;
	z-index: 1000;
	padding: 15px 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: 0.7s;

	&.visible {
		opacity: 1;
		pointer-events: all;
	}
`;

export const Info = styled.div`
	font-size: 12px;
	padding-right: 20px;
	max-width: 70%;
`;

export const Button = styled.button`
	width: 200px;
	padding: 10px;
	border-radius: 3px;
	font-weight: bold;
	color: inherit;
	border: 0;
	background-color: var(--brand-primary);
	color: var(--neutral-strongest);
`;

export const Text = styled.p``;

export const Hyperlink = styled.a`
	color: var(--brand-primary);
`;

export const CloseButton = styled.span`
	font-size: 12px;
	color: #737272;
	position: absolute;
	right: 10px;
	top: 10px;
	width: 10px;
	cursor: pointer;
`;
